import {APIStatus} from '@web/core/constants'

import {DELIVERY_MANAGER_STEP} from '../constants'
import {AddressSearch, AddressSearchQuery, DeliveryAddress, DeliveryManagerState, OrderInfo} from '../interfaces'

export const getInitialAddressSearchQuery = (): AddressSearchQuery => ({
    keyword: '',
    allowSixDigitCode: false,
    page: 1,
    regionCode: null,
})
export const getEmptyAddressSearch = (): AddressSearch => ({
    query: {keyword: '', allowSixDigitCode: false, page: 1, regionCode: null},
    status: APIStatus.IDLE,
    totalCount: 0,
    regionCountResult: [],
    addressResult: [],
})
export const getEmptyDeliveryAddress = (): DeliveryAddress => ({
    hash: '',
    addressName: '',
    addressNameBadge: null,
    receiverName: '',
    zipCode: '',
    buildingManagementNo: '',
    locationX: '',
    locationY: '',
    baseAddress: '',
    detailAddress: null,
    isRoadNameAddress: false,
    telNo1: '',
    telNo2: null,
    isPrimaryAddress: false,
    isRegistered: false,
})

export const getInitialOrderInfo = (): OrderInfo => ({
    originalAddressHash: '',
    isOverseasDelivery: false,
    hasArrivalGuaranteeProduct: false,
    deliveryMemo: {
        memoList: [],
        options: {
            particularMemo: {
                usable: false,
                used: false,
            },
            saveAsDefaultMemo: false,
        },
    },
    virtualPhoneNumber: {
        usable: false,
        used: false,
    },
    personalCustomsCode: null,
})

export const getInitialState = (): DeliveryManagerState => ({
    address: null,
    deliveryAddress: null,
    addressSearch: getEmptyAddressSearch(),
    deliveryAddressBook: {
        selectedHash: null,
        status: APIStatus.IDLE,
        deliveryAddressList: [],
        isAddible: false,
    },
    memoBook: [],
    orderInfo: getInitialOrderInfo(),
    options: {
        type: null,
        closeType: null,
        postMessageKey: null,
        returnUrl: null, // 'http://example.com',
    },
    status: {
        scene: null,
        historyCountFromBase: 0,
        step: DELIVERY_MANAGER_STEP.IDLE,
    },
})
